import * as React from 'react';
import { TableFetchParams, tableQueryMaker } from '@core/table';
import { useService } from '@core/inversify-react';

import { GetUsersRepoType, IGetUsersRepo } from '../../repos';
import { UsersTableContext } from '../../contexts';

export const useUsersTableContext = () => {
  const getUsersRepo = useService<IGetUsersRepo>(GetUsersRepoType);

  const onFetch = React.useCallback(
    async (params: TableFetchParams) => {
      const result = await getUsersRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getUsersRepo],
  );

  return { onFetch, context: UsersTableContext };
};
